import StoreSearchTab from "../../../components/tabs/StoreSearchTab";
import "../../../styles/stores/makeTransactions/cashTransactions.css";
import SelectProduct from "./SelectProduct";
import TransactionSuccess from "./TransactionSuccess";
import ConfirmSelection from "./ConfirmSelection";
import CashTransactionComp from "./CashTransactionComp";
import { useState, useEffect, useRef } from "react";
import { ModalAlert } from "../../../components/alerts/modalAlert";
import FinalProductCheck from "./FinalProductCheck";
import ProductConfirmation from "./ProductConfirmation/ProductConfirmation";
import CustomerDetails from "./operationTypeCustomerDetails/OperationType";
import BookedQuotations from "./bookOrder/ViewBookedOrder";

const CashTransaction = ({ openCheckSales, socket, setOpenPromptToSync, noProductCreated }) => {
  console.log("Rendering CashTransaction component");

  const [alertDisplay, setAlertDisplay] = useState({
    showAlert: false,
    type: "",
    title: "",
    message: "",
  });

  const [isCashTransaction, setIsCashTransaction] = useState(true);
  const [componentToRender, setComponentToRender] = useState("CashTransactionComp");
  const [createdTransaction, setCreatedTransaction] = useState({});
  const [showQueriedTransaction, setShowQueriedTransaction] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [queriedTransactionID, setQueriedTransactionID] = useState("");
  const [fetchYesterdayTrans, setFetchYesterdayTrans] = useState(null); // to fetch yesterday transaction
  const [fetchTodayTrans, setFetchTodayTrans] = useState(null); // to fetch today transaction
  const [fetchCustomTrans, setFetchCustomTrans] = useState(null); // to fetch custom transaction format {fromDate, toDate}
  const [displayedTimeline, setDisplayedTimeline] = useState("Today");
  const [transactionCount, setTransactionCount] = useState({
    paid: null,
    unpaid: null,
  });
  const [transactionInsights, setTransactionInsights] = useState({
    totalClearedLoanToday: null,
    totalNotSupplied: null,
    totalLoanDueToday: null,
    totalAmountOnLoanToday: null,
    totalPaidAmount: null,
  });

  /*   const isFirstRender = useRef(true); */
  /*  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // 🚫 skip on first render
    }
    console.log("changed");
    setQueriedTransactionID("");
  }, [showQueriedTransaction]); */

  /* 
  searchString={queriedTransactionID} even though the name is transID, it is used to search for both cash and loan transactions based on the productname
   */

  return (
    <>
      <div className='CashTranWrapper'>
        {componentToRender === "CashTransactionComp" && (
          <div style={{ position: "relative", height: "100%" }}>
            <div style={{ overflowX: "hidden", height: "100%" }}>
              <StoreSearchTab
                transType={isCashTransaction}
                updateTransType={setIsCashTransaction}
                transID={queriedTransactionID}
                updateQueryID={setQueriedTransactionID}
                showQueriedTrans={setShowQueriedTransaction}
                getYesterdayTrans={setFetchYesterdayTrans}
                getTodayTrans={setFetchTodayTrans}
                getCustomTrans={setFetchCustomTrans}
                setDisplayedTimeline={setDisplayedTimeline}
                displayedTimeline={displayedTimeline}
                transactionCount={transactionCount}
                transactionInsights={transactionInsights}
                searchString={searchString}
                updateSearchString={setSearchString}
                whichCompToRender={setComponentToRender}
              />
              <div className='transactionHideDiv'>
                <CashTransactionComp
                  transType={isCashTransaction}
                  loan={false}
                  whichCompToRender={setComponentToRender}
                  openCheckSales={openCheckSales}
                  setAlertDisplay={setAlertDisplay}
                  searchString={searchString}
                  showQueriedTrans={showQueriedTransaction}
                  updateShowQueriedTrans={setShowQueriedTransaction}
                  socket={socket}
                  fetchYesterdayTrans={fetchYesterdayTrans}
                  fetchTodayTrans={fetchTodayTrans}
                  fetchCustomTrans={fetchCustomTrans}
                  displayedTimeline={displayedTimeline}
                  updateTodayTrans={setDisplayedTimeline}
                  updateTransactionCount={setTransactionCount}
                  setTransactionInsights={setTransactionInsights}
                  transID={queriedTransactionID}
                  noProductCreated={noProductCreated}
                />
              </div>
            </div>
          </div>
        )}
        {componentToRender === "SelectProduct" && (
          <SelectProduct
            whichCompToRender={setComponentToRender}
            setAlertDisplay={setAlertDisplay}
            getYesterdayTrans={setFetchYesterdayTrans}
            getTodayTrans={setFetchTodayTrans}
            getCustomTrans={setFetchCustomTrans}
          />
        )}

        {componentToRender === "FinalProductCheck" && <ProductConfirmation whichCompToRender={setComponentToRender} />}
        {/* {componentToRender === "FinalProductCheck" && <FinalProductCheck whichCompToRender={setComponentToRender} />} */}
        {componentToRender === "ConfirmSelection" && (
          <CustomerDetails
            whichCompToRender={setComponentToRender}
            createdTransaction={setCreatedTransaction}
            setAlertDisplay={setAlertDisplay}
            socket={socket}
          />
        )}
        {componentToRender === "viewBookedOrderComp" && <BookedQuotations whichCompToRender={setComponentToRender} />}
        {/*  {componentToRender === "ConfirmSelection" && (
          <ConfirmSelection
            whichCompToRender={setComponentToRender}
            createdTransaction={setCreatedTransaction}
            setAlertDisplay={setAlertDisplay}
            socket={socket}
          />
        )} */}
        {componentToRender === "TransactionSuccess" && (
          <TransactionSuccess
            whichCompToRender={setComponentToRender}
            transactionDetails_={createdTransaction}
            setAlertDisplay={setAlertDisplay}
            setOpenPromptToSync={setOpenPromptToSync}
          />
        )}

        <ModalAlert
          type={alertDisplay.type}
          showAlert={alertDisplay.showAlert}
          title={alertDisplay.title}
          message={alertDisplay.message}
          setAlertDisplay={setAlertDisplay}
        />
      </div>
    </>
  );
};

export default CashTransaction;
{
  /*  <div>
        <TransactionSuccess /> 
        </div> */
}
{
  /* 
            <ConfirmSelection />
            */
}
{
  /* <TransactionSuccess />  */
}
